import { Button, ButtonSpinner, ButtonText } from '@/components/ui/button'
import { Center } from '@/components/ui/center'
import { Input, InputField } from '@/components/ui/input'
import { VStack } from '@/components/ui/vstack'
import useDefaultToast from '@/components/useDefaultToast'
import { loginThunk } from '@/redux/slices/sessionSlice'
import { useAppDispatch } from '@/redux/store'
import { useRouter } from 'expo-router'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import handleLoginResult from './handleLoginResult'

export default function LoginViaIdentity() {
  const { t } = useTranslation('login')
  const dispatch = useAppDispatch()
  const toast = useDefaultToast()
  const router = useRouter()

  const [identity, setIdentity] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)

  const handleButtonPress = async () => {
    setLoading(true)
    try {
      const result = await dispatch(loginThunk({ identity: identity.toLowerCase().trim(), password })).unwrap()
      handleLoginResult({ router, loginResult: result })
    } catch (error: any) {
      const message = error?.message || t('identityLogin.identityOrPasswordIncorrect')
      toast.show(message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Center>
      <VStack space="3xl" className="p-8 max-w-[540] w-full">
        <VStack space="lg">
          <Input size="lg">
            <InputField
              placeholder={t('identityLogin.identityPlaceholder')}
              value={identity}
              onChangeText={setIdentity}
              lineBreakModeIOS="clip"
              autoCapitalize="none"
            />
          </Input>
          <Input size="lg">
            <InputField
              type="password"
              placeholder={t('identityLogin.passwordPlaceholder')}
              value={password}
              onChangeText={setPassword}
              lineBreakModeIOS="clip"
            />
          </Input>
        </VStack>
        <Button size="lg" onPress={handleButtonPress} disabled={loading}>
          {loading && <ButtonSpinner />}
          <ButtonText>{t('login')}</ButtonText>
        </Button>
      </VStack>
    </Center>
  )
}
